import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ExternalLink, AlertTriangle, CheckCircle } from "lucide-react";

const ManualDeletionGuide = ({ show, onHide, userEmail }) => {
  const openFirebaseConsole = () => {
    window.open("https://console.firebase.google.com/", "_blank");
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          <AlertTriangle className="text-warning me-2" size={24} />
          Manual User Deletion Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-warning">
          <strong>Important:</strong> The user has been removed from the database, but you need to manually delete them from Firebase Authentication to complete the process.
        </div>

        <h6 className="fw-bold mb-3">Steps to Delete User from Firebase Authentication:</h6>
        
        <div className="step-list">
          <div className="d-flex mb-3">
            <div className="step-number me-3">
              <span className="badge bg-primary rounded-circle">1</span>
            </div>
            <div>
              <strong>Open Firebase Console</strong>
              <p className="text-muted mb-2">Click the button below to open Firebase Console in a new tab</p>
              <Button 
                variant="outline-primary" 
                size="sm" 
                onClick={openFirebaseConsole}
                className="d-flex align-items-center"
              >
                <ExternalLink size={16} className="me-2" />
                Open Firebase Console
              </Button>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div className="step-number me-3">
              <span className="badge bg-primary rounded-circle">2</span>
            </div>
            <div>
              <strong>Navigate to Authentication</strong>
              <p className="text-muted">Select your project → Authentication → Users</p>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div className="step-number me-3">
              <span className="badge bg-primary rounded-circle">3</span>
            </div>
            <div>
              <strong>Find the User</strong>
              <p className="text-muted">Look for user with email: <code>{userEmail}</code></p>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div className="step-number me-3">
              <span className="badge bg-primary rounded-circle">4</span>
            </div>
            <div>
              <strong>Delete the User</strong>
              <p className="text-muted">Click the three dots menu → Delete user → Confirm deletion</p>
            </div>
          </div>
        </div>

        <div className="alert alert-info mt-4">
          <CheckCircle size={16} className="me-2" />
          <strong>Why is this necessary?</strong> Firebase doesn't allow client-side deletion of authentication users for security reasons. This requires admin privileges that can only be used server-side.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          I'll do this later
        </Button>
        <Button variant="primary" onClick={openFirebaseConsole}>
          Open Firebase Console Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManualDeletionGuide;
